// extracted by mini-css-extract-plugin
module.exports = {"avatar":"On3Avatar_avatar___8iTG","radiusFive":"On3Avatar_radiusFive__nLs3C","teamAvatar":"On3Avatar_teamAvatar__PPsM6"};